module.exports = __webpack_public_path__ + "moms-best-friend.jpg?f2b6d543ff9ada403774ca132b4a1d89";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/moms-best-friend.jpg
// module id = 122
// module chunks = 0